import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";

export const unauthorizedInterceptor: HttpInterceptorFn = (request, next) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const condition1 = error.status === 401;
      if (
        condition1
      ) {
        if (error.error.code === 33) {
          router.navigate(['/choose-account'], { queryParams: { type: 'blocked' } }).then();
        } else if (error.error.code === 34) {
          router.navigate(['/choose-account'], { queryParams: { type: 'revoked' } }).then();
        } else {
          authService.logout(() => { router.navigate(['/login']).then() });
        }
      }
      return throwError(() => error);
    }));
};
